(() => {
  if (window.__cbxProductPaymentCompatInstalled) return;
  window.__cbxProductPaymentCompatInstalled = true;
  const label = document.currentScript?.dataset.addToCartLabel || 'Add to cart';
  const selector = '.shopify-payment-button__more-options';
  const scopes = new Map();

  function decorate(element) {
    if (!(element instanceof HTMLElement) || element.dataset.modified) return;
    element.dataset.modified = 'true';
    element.classList.add('button', 'button--lg');
    element.textContent = label;
    element.style.display = 'inline-block';
  }

  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(selector)) decorate(node);
    node.querySelectorAll(selector).forEach(decorate);
  }

  function mount(root = document) {
    const sections = [...root.querySelectorAll('.shopify-section--main-product')];
    if (root instanceof Element && root.matches('.shopify-section--main-product')) sections.unshift(root);
    sections.forEach(section => {
      if (scopes.has(section)) return;
      const abort = new AbortController();
      section.addEventListener('click', event => {
        if (!(event.target instanceof Element) || !event.target.closest(selector)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const button = [...section.querySelectorAll('.product-info__buy-buttons button[type="submit"], buy-buttons button[type="submit"], form[is="product-form"] button[type="submit"]')]
          .find(element => element instanceof HTMLButtonElement && !element.disabled);
        button?.click();
      }, { capture: true, signal: abort.signal });
      // One initial scan. Later inspect added subtrees only, not the whole body.
      scan(section);
      const observer = new MutationObserver(records => {
        records.forEach(record => record.addedNodes.forEach(scan));
      });
      observer.observe(section, { childList: true, subtree: true });
      scopes.set(section, { observer, abort });
    });
  }

  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    scopes.forEach((state, section) => {
      if (section === event.target || event.target.contains(section)) {
        state.observer.disconnect();
        state.abort.abort();
        scopes.delete(section);
      }
    });
  });
  mount();
})();
